import { client } from "utils/api";

const getBrands = (q) =>
  new Promise(async (resolve, reject) => {
    try {
      const { data } = await client.get(
        `/brands?context=list${q ? `&q[name_matches]=%25${q}%25` : ""}`,
      );
      const options = data.map(({ name }) => ({
        label: name,
        value: name,
      }));
      resolve(options);
    } catch (error) {
      console.log(error);
      reject([]);
    }
  });

export default getBrands;
